<template>
    <div class="md pageination">
        <ul class="func">
            <li class="first">
                <cpBtn
                    icon="first_page"
                    themes="forth"
                    extendClass='is-hover'
                    :title="$t('site.func.pageination.first')"
                    @click="changeByPage(1)"
                ></cpBtn>
            </li>
            <li class="prev">
                <cpBtn
                    icon="chevron_left"
                    themes="forth"
                    extendClass='is-hover'
                    :title="$t('site.func.pageination.prev')"
                    @click="changeByPage(page - 1)"
                ></cpBtn>
            </li>
        </ul>
        <ul class="selecter">
            <li
                v-for="n in useNumber"
                :key="n"
                :class="[n === page? 'is-active': '']"
            >
                <a @click="changeByPage(n)">{{ n }}</a>
            </li>
            <!-- <li>
                <select :value="page" @change="changeByPage($event.target.value)">
                    <option v-for="n in number" :value="n" :key="'page-'+ n">{{n}}</option>
                </select>
            </li>
            <li>
                <select :value="setLength" @change="changeByLength($event.target.value)">
                    <option v-for="select in lengthSelect" :key="select" :value="select">{{ select }}</option>
                </select>
            </li> -->
        </ul>
        <div class="essay">
            <span>{{ $t('site.func.pageination.page') }}</span>
            <select :value="page" @change="changeByPage($event.target.value)">
                <option v-for="n in number" :value="n" :key="'page-'+ n">{{n}}</option>
            </select>
            <span> / {{ number }}</span>
        </div>
        <ul class="func">
            <li class="next">
                <cpBtn
                    icon="chevron_right"
                    themes="forth"
                    extendClass='is-hover'
                    :title="$t('site.func.pageination.next')"
                    @click="changeByPage(page + 1)"
                ></cpBtn>
            </li>
            <li class="last">
                <cpBtn
                    icon="last_page"
                    themes="forth"
                    extendClass='is-hover'
                    :title="$t('site.func.pageination.last')"
                    @click="changeByPage(number)"
                ></cpBtn>
            </li>
        </ul>
    </div>
</template>

<script>
    import cpBtn from '@/components/cpBtn'

    export default {
        components: {
            cpBtn,
        },
        props: {
            page: { //目前第幾頁
                type: Number,
                required: false,
                default: 1
            },
            setLength: { //自訂頁數
                type: Number,
                required: false,
                default: 0
            },
            selector: {
                type: Array,
                required: false,
                default: function () {
                    return []
                }
            },
            length: { //總共有幾筆
                type: Number,
                required: false,
                default: 0
            }
        },
        data: function(){
            let $selector = this.selector,
                _pageLength = this.setLength || 10;

            if( $selector.includes(_pageLength) === false ) {
                $selector.push(_pageLength);

                $selector.sort((a, b) => {

                    if( a > b ) {
                        return 1;
                    }else if( a < b ) {
                        return -1;
                    }
                });
            }

            return {
                lengthSelect: $selector
            }
        },
        computed: {
            number: function(){ //總共多少頁
                let _num = Math.ceil(this.length / this.setLength);

                if( isNaN(_num) ){
                    _num = 1;
                }

                return _num;
            },
            useNumber: function(){
                let _max = 7,
                    _helf = Math.floor(_max / 2);

                if( this.number < _max ) {
                    return this.number
                }else if( this.page - _helf <= 0 ) {
                    return _max;
                }else if( this.page + _helf >= this.number ){
                    let $result = []

                    for( let _i = _max - 1; _i >= 0; _i-- ) {
                        $result.push(this.number - _i); 
                    }

                    return $result;
                }else {
                    console.log(4)

                    let _base = this.page - _helf,
                        $result = []

                    for( let _i = 0; _i <= _max; _i++ ) {
                        $result.push(_base + _i);
                    }

                    return $result;
                }
            }
        },
        watch: {
            number: {
                handler: function(){
                    let _number = this.number,
                        _page = this.page;

                    if( _page > _number ) {
                        this.changeByPage(_number);
                    }
                },
            },
        },
        methods: {
            changeByLength: function(length){
                this.$emit('sendEvent', 'changeByLength', length);
            },
            changeByPage: function(page){
                let _page = page;

                _page = Math.max(_page, 1);
                _page = Math.min(_page, this.number);

                this.$emit('sendEvent', 'changeByPage', _page);
            }
        }
    }
</script>

<style scoped lang="scss">

    .md.pageination {
        padding-top: $interval-m;
        text-align: center;
        display: flex;
        justify-content: center;

        /*ul*/.func {
            @extend %reset;
            vertical-align: middle;

            @include media('mobile') {
                display: none;
            }

            li {
                display: inline-block;
                vertical-align: middle;

                &.first {
                    
                }

                &.prev {

                }

                &.next {

                }

                &.last {
                    
                }
            }

            a {

            }
        }

        .selecter {
            @extend %reset;
            vertical-align: middle;
            margin: 0 $interval-m;

            @include media('mobile') {
                display: none;
            }

            li {
                display: inline-block;

                + li {
                    margin-left: $interval-xs;
                }

                &.is-active {
                    
                    a {
                        background-color: $major-color;
                        color: $white;
                    }
                }
            }

            a {
                $size: 34px;
                
                line-height: $size;
                height: $size;
                min-width: $size;
                text-align: center;
                display: block;
                border-radius: 100%;
                cursor: pointer;
            }
        }

        .essay {
            display: none;
            vertical-align: middle;

            @include media('mobile') {
                display: block;
            }


            select {
                width: auto;
                margin: 0 $interval-s;
            }

            span {
                display: inline-block;
                vertical-align: middle;
            }
        }
    }
</style>